import html2canvas from 'html2canvas';
import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import visitingCard from '../../assets/digital_visiting_card/digital-visiting-card.jpg';
import downloadIcon from '../../assets/common/download-icon.png';
import LanguageIcon from '../../assets/common/language.svg';
import RandomProfileImg from '../../assets/digital_visiting_card/random-profile.jpg';
import shareIcon from '../../assets/common/share-icon.png';
import { useCommonContext } from '../../commonContextProvider';
import { FormattedMessage } from "react-intl";
import { useAuthContext } from '../../authContextProvider';
import './style.scss';


const DigitalVisitingCard = () => {
    const printRef = useRef<any>();
    const { toggleLanguage } = useCommonContext();
    const [userInfo, setUserInfo] = useState<any>();
    const [searchParams, setSearchParams] = useSearchParams();
    const { trackEvent, userData }: any = useAuthContext();
    
    useEffect(() => {
        if(userData.user_id){
            setUserInfo({
                name: userData.name,
                businessName: userData.business_name,
                location: userData.location,
                profileImg: userData.profile_img
            });
        }
    }, []);

    const handleDownloadImage = async () => {
        if (printRef) {
            const element = printRef.current;
            const canvas = await html2canvas(element)
            const data = canvas.toDataURL('image/jpg');
            const link = document.createElement('a');

            if (typeof link.download === 'string') {
                link.href = data;
                link.download = 'image.jpg';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                window.open(data);
            }

            const eventData = {
                event_type: "click",
                action: "download"
            };

            trackEvent('mob_digital_card_action', eventData, 'custom_tabs');
        }

    }

    const handleShareImage = async () => {
        if (!printRef) return
        try {
            const element = printRef.current;
            const canvas = await html2canvas(element);
            canvas.toBlob((blob: any) => {
                const newBlob = new Blob([blob], { type: "image/jpeg" });
                const file = new File([newBlob], 'image.jpg', { type: newBlob.type });

                if (navigator.share) {
                    navigator.share({
                        files: [file]
                    });
                } else {
                    alert('please use a different browser')
                }
            });
            const eventData = {
                event_type: "click",
                action: "share"
            };
            trackEvent('mob_digital_card_action', eventData, 'share_bottom_sheet');
        } catch (err: any) {
            console.log(err.name, err.message);
        }
    }

    return (
        <div className='main-container-visiting-card'>
            <div className='poster-header'>
                <p className='heading'> <FormattedMessage id='visiting.card.heading' /> </p>
                <img src={LanguageIcon} alt="language-icon" onClick={toggleLanguage} width='20px' />
            </div>
            <div style={{ position: 'relative', width: '340px', margin: '0 auto', marginTop: '50px', textAlign: 'center' }} ref={printRef}>
                <span className='business-name'>{userInfo?.businessName}</span>
                <span className='user-name'>{userInfo?.name}</span>
                <span className='location'>{userInfo?.location}</span>
                <img className='profile-img' src={RandomProfileImg} alt="profile-image" />
                <img src={visitingCard} alt='visiting-card' style={{ width: '100%' }} />
            </div>
            <p className='description'> <FormattedMessage id='visiting.card.description' /> </p>
            <div className='footer'>
                <button onClick={handleShareImage}> <FormattedMessage id='share' /> <img src={shareIcon} className='action-btn' /> </button>
                <button onClick={handleDownloadImage}> <FormattedMessage id='download' /> <img src={downloadIcon} className='action-btn' /> </button>
            </div>
        </div>
    )
}

export default DigitalVisitingCard;